import React from "react";
import style from "./StatCard.module.css";

const StatCard = ({ title, value, description, bgColor, textColor, icon }) => {
  return (
    <div className={style.card} style={{ backgroundColor: bgColor }}>
      <div className={style.ValuesWrapper}>
        <p className={style.headPara}>{title}</p>
        <div className={style.countWrapper}>
          <p className={style.value} style={{ color: textColor }}>
            {value}
          </p>
          <p className={style.desPara}>{description}</p>
        </div>
      </div>
      <div className={style.imgContainer}>
        <img src={icon} alt="" />
      </div>
    </div>
  );
};

export default StatCard;
